(function () {
    function lhm_getBilderSliderVisible(width) {
        if (width >= 1366) return 5;
        if (width >= 768) return 3;
        return 1;
    }

    function lhm_getBilderSliderActiveItem(track, items) {
        const scrollLeft = track.scrollLeft;
        const maxScrollLeft = track.scrollWidth - track.clientWidth;

        if (scrollLeft >= maxScrollLeft - 1) {
            return items.length - 1;
        }

        let activeItem = 0;

        items.forEach((item, i) => {
            if (item.offsetLeft <= scrollLeft + 1) {
                activeItem = i;
            }
        });

        return activeItem;
    }

    function lhm_cancelBilderSliderAnim(track) {
        if (track._bilderSliderAnimFrame) {
            cancelAnimationFrame(track._bilderSliderAnimFrame);
            track._bilderSliderAnimFrame = null;
        }
    }

    function lhm_animateBilderSliderScroll(track, targetLeft, duration = 350, onComplete) {
        lhm_cancelBilderSliderAnim(track);

        const startLeft = track.scrollLeft;
        const delta = targetLeft - startLeft;
        const startTime = performance.now();

        function step(now) {
            const t = Math.min(1, (now - startTime) / duration);
            const eased = 1 - Math.pow(1 - t, 3);
            track.scrollLeft = startLeft + delta * eased;

            if (t < 1) {
                track._bilderSliderAnimFrame = requestAnimationFrame(step);
            } else {
                track._bilderSliderAnimFrame = null;

                if (onComplete) {
                    onComplete();
                }
            }
        }

        track._bilderSliderAnimFrame = requestAnimationFrame(step);
    }

    function lhm_scrollBilderSliderToItem(track, item) {
        if (!item) {
            return;
        }

        const items = track.children;
        let targetLeft = item.offsetLeft;

        if (item === items[0]) {
            targetLeft = 0;
        } else if (item === items[items.length - 1]) {
            targetLeft = track.scrollWidth - track.clientWidth;
        }

        lhm_animateBilderSliderScroll(track, targetLeft);
    }

    function lhm_getBilderSliderNearestItem(track, items) {
        const scrollLeft = track.scrollLeft;
        let nearest = items[0];
        let nearestDistance = Infinity;

        items.forEach((item) => {
            const distance = Math.abs(item.offsetLeft - scrollLeft);

            if (distance < nearestDistance) {
                nearestDistance = distance;
                nearest = item;
            }
        });

        return nearest;
    }

    function lhm_stepBilderSlider(track, items, direction) {
        const current = lhm_getBilderSliderActiveItem(track, items);
        const target = Math.min(items.length - 1, Math.max(0, current + direction));

        lhm_scrollBilderSliderToItem(track, items[target]);
    }

    function lhm_updateBilderSlider(slider, { resnap } = {}) {
        const track = slider.querySelector('.bilderSliderTrack');
        const progress = slider.querySelector('.bilderSliderProgress');
        const fill = progress ? progress.querySelector('.bilderSliderProgressFill') : null;

        if (!track) {
            return;
        }

        const total = parseInt(slider.dataset.count, 10) || 0;
        const width = window.innerWidth;
        const visible = lhm_getBilderSliderVisible(width);
        const needsPeek = total > visible;

        slider.classList.toggle('bilderSliderOuter-hasSlider', needsPeek);
        slider.classList.toggle('bilderSliderOuter-noSlider', !needsPeek);

        const items = Array.from(track.children);
        const activeItemBeforeResnap = lhm_getBilderSliderActiveItem(track, items);

        if (resnap && items[activeItemBeforeResnap]) {
            track.scrollTo({ left: items[activeItemBeforeResnap].offsetLeft, behavior: 'auto' });
        }

        if (!progress || !fill) {
            return;
        }

        progress.classList.toggle('bilderSliderProgress-visible', needsPeek);

        if (!needsPeek) {
            return;
        }

        const activeItem = lhm_getBilderSliderActiveItem(track, items);
        const segmentWidthPercent = total > 0 ? 100 / total : 0;

        fill.style.width = segmentWidthPercent + '%';
        fill.style.left = (segmentWidthPercent * activeItem) + '%';
        progress.setAttribute('aria-valuenow', activeItem + 1);
        progress.setAttribute('aria-valuetext', `Bild ${activeItem + 1} von ${total}`);
    }

    function lhm_initBilderSliderProgress(slider, track) {
        const progress = slider.querySelector('.bilderSliderProgress');

        if (!progress) {
            return;
        }

        progress.addEventListener('click', (e) => {
            const items = Array.from(track.children);
            const total = items.length;

            if (total === 0) {
                return;
            }

            const rect = progress.getBoundingClientRect();
            const ratio = rect.width > 0 ? Math.min(1, Math.max(0, (e.clientX - rect.left) / rect.width)) : 0;
            const index = Math.min(total - 1, Math.floor(ratio * total));

            progress.focus({ preventScroll: true });
            lhm_scrollBilderSliderToItem(track, items[index]);
        });

        progress.addEventListener('keydown', (e) => {
            const items = Array.from(track.children);

            if (e.key === 'ArrowRight') {
                e.preventDefault();
                lhm_stepBilderSlider(track, items, 1);
            }

            if (e.key === 'ArrowLeft') {
                e.preventDefault();
                lhm_stepBilderSlider(track, items, -1);
            }

            if (e.key === 'Home') {
                e.preventDefault();
                lhm_scrollBilderSliderToItem(track, items[0]);
            }

            if (e.key === 'End') {
                e.preventDefault();
                lhm_scrollBilderSliderToItem(track, items[items.length - 1]);
            }
        });
    }

    function lhm_initBilderSliderDrag(track) {
        let isPointerDown = false;
        let dragged = false;
        let startX = 0;
        let scrollStart = 0;
        let pendingLeft = null;

        function applyScroll() {
            if (pendingLeft !== null) {
                track.scrollLeft = pendingLeft;
                pendingLeft = null;
            }
        }

        function onMove(e) {
            if (!isPointerDown) {
                return;
            }

            const delta = e.clientX - startX;

            if (!dragged && Math.abs(delta) > 10) {
                dragged = true;
                track.classList.add('bilderSliderTrack-dragging');
            }

            if (dragged) {
                const isFirstPending = pendingLeft === null;
                pendingLeft = scrollStart - delta;

                if (isFirstPending) {
                    requestAnimationFrame(applyScroll);
                }
            }
        }

        function endDrag(e) {
            isPointerDown = false;
            track.classList.remove('bilderSliderTrack-dragging');
            track.releasePointerCapture(e.pointerId);

            if (dragged) {
                const items = Array.from(track.children);
                lhm_scrollBilderSliderToItem(track, lhm_getBilderSliderNearestItem(track, items));
            }
        }

        track.addEventListener('pointerdown', (e) => {
            if (e.pointerType === 'touch') {
                return;
            }

            e.preventDefault();
            track.setPointerCapture(e.pointerId);
            track.focus();
            lhm_cancelBilderSliderAnim(track);
            isPointerDown = true;
            dragged = false;
            startX = e.clientX;
            scrollStart = track.scrollLeft;
        });

        track.addEventListener('pointermove', onMove);
        track.addEventListener('pointerup', endDrag);
        track.addEventListener('pointercancel', endDrag);
    }

    function lhm_initBilderSliderSection(section) {
        section.querySelectorAll('.bilderSliderOuter').forEach((slider) => {
            const track = slider.querySelector('.bilderSliderTrack');

            if (!track) {
                return;
            }

            lhm_updateBilderSlider(slider);
            lhm_initBilderSliderDrag(track);
            lhm_initBilderSliderProgress(slider, track);

            let scrollTicking = false;
            track.addEventListener('scroll', () => {
                if (!scrollTicking) {
                    scrollTicking = true;
                    requestAnimationFrame(() => {
                        lhm_updateBilderSlider(slider);
                        scrollTicking = false;
                    });
                }
            }, { passive: true });

            let resizeTimeout = null;
            window.addEventListener('resize', () => {
                clearTimeout(resizeTimeout);
                resizeTimeout = setTimeout(() => {
                    lhm_updateBilderSlider(slider, { resnap: true });
                }, 150);
            }, { passive: true });
        });
    }

    function lhm_initBilderslider() {
        document.querySelectorAll('.layoutBilderslider').forEach(lhm_initBilderSliderSection);
    }

    window.lhm_initBilderSliderSection = lhm_initBilderSliderSection;

    window.addEventListener('load', lhm_initBilderslider);
})();
